import { Button, Icon, Image, useDisclosure } from '@chakra-ui/react'
import { FaArrowRight } from 'react-icons/fa6'
import StripeIndividual from './individual'
import { useUser } from '@/src/store/user-store'
import VerifyPhoneEmail from '../breakdown-popups/verifyphoneemail'
import UnderReviewModal from '../breakdown-popups/underreview-modal'
import { useEffect, useState } from 'react'
import Redeem from '../breakdown-popups/redeem'

export default function StripeRedeemAndVerificationFlow({
  flowType,
  openStripe,
}: {
  flowType: 'redeem' | 'verification'
  openStripe?: boolean
}) {
  const { user, _hasHydrated } = useUser()
  // const verificationStatus = useStripeVerificationStatusQuery()
  const [currentStep, setCurrentStep] = useState(0)
  const [verificationError, setVerificationError] = useState<string | null>(
    null
  )
  const {
    isOpen: isOpenRedeem,
    onOpen: onOpenRedeem,
    onClose: onCloseRedeem,
  } = useDisclosure()

  const {
    isOpen: isOpenUnderReview,
    onOpen: onOpenUnderReview,
    onClose: onCloseUnderReview,
  } = useDisclosure()

  const {
    isOpen: isMobileOtpVerifyOpen,
    onOpen: onOpenMobileOtpVerify,
    onClose: onCloseMobileOtpVerify,
  } = useDisclosure()

  const {
    isOpen: isStripeOpen,
    onOpen: onStripeOpen,
    onClose: onStripeClose,
  } = useDisclosure()

  // const getVerificationError = (): {
  //   type: 'personal' | 'bank' | 'verification'
  //   message: string | undefined
  // } | null => {
  //   if (verificationStatus?.data?.verify_error?.length == 0) {
  //     return null
  //   }
  //   if (
  //     verificationStatus?.data?.verify_error?.some((e) => e.cat === 'personal')
  //   ) {
  //     return {
  //       type: 'personal',
  //       message: verificationStatus?.data?.verify_error?.find(
  //         (e) => e.cat === 'personal'
  //       )?.reason,
  //     }
  //   }
  //   if (verificationStatus?.data?.verify_error?.some((e) => e.cat === 'bank')) {
  //     return {
  //       type: 'bank',
  //       message: verificationStatus?.data?.verify_error?.find(
  //         (e) => e.cat === 'bank'
  //       )?.reason,
  //     }
  //   }

  //   if (
  //     verificationStatus?.data?.verify_error?.some(
  //       (e) => e.cat === 'verification'
  //     )
  //   ) {
  //     return {
  //       type: 'verification',
  //       message: verificationStatus?.data?.verify_error?.find(
  //         (e) => e.cat === 'verification'
  //       )?.reason,
  //     }
  //   }

  //   return null
  // }

  const onFlowBegin = () => {
    if (user?.mobileotpverify !== '1') {
      onOpenMobileOtpVerify()
      return
    } else if (user?.stripeOnboard !== '1') {
      onStripeOpen()
      return
    } else if (user?.stripeOnboard === '1') {
      onOpenRedeem()
      return
    }

    // const verificationError = getVerificationError()

    // if (verificationError && verificationError.message) {
    //   setVerificationError(verificationError.message)
    //   setCurrentStep(getStepFromType(verificationError.type))
    //   onStripeOpen()
    //   return
    // }

    // if (verificationStatus.data?.progress.personal_level == '0') {
    //   onStripeOpen()
    // } else if (
    //   verificationStatus.data?.progress.personal_level == '1' &&
    //   verificationStatus.data?.progress.bank_level == '0'
    // ) {
    //   onStripeOpen()
    //   setCurrentStep(2)
    // } else if (
    //   verificationStatus.data?.progress.bank_level == '1' &&
    //   verificationStatus.data?.progress.verify_level == '0'
    // ) {
    //   onStripeOpen()
    //   setCurrentStep(3)
    // } else if (
    //   verificationStatus.data?.progress.verify_level == '1' &&
    //   (verificationStatus.data?.verify_error == null ||
    //     verificationStatus.data?.verify_error.length == 0)
    // ) {
    //   onOpenUnderReview()
    // } else if (
    //   verificationStatus.data?.payout_enabled == '1' &&
    //   flowType === 'redeem'
    // ) {
    //   onOpenRedeem()
    // }
  }
  useEffect(() => {
    if (openStripe) {
      onFlowBegin()
    }
  }, [openStripe])
  const handleOTPVerifiedClose = () => {
    onCloseMobileOtpVerify()
    onStripeOpen()
  }

  const [verified, setVerified] = useState(false)

  useEffect(() => {
    if (user?.stripeOnboard === '1') {
      setVerified(true)
    }
  }, [user])
  useEffect(() => {
    if (currentStep === 3) {
      onStripeClose()
      onOpenRedeem()
    }
  }, [currentStep])
  return (
    <>
      {flowType === 'redeem' ? (
        <Button
          // leftIcon={
          //   <Image
          //     src={'/rewards/breakdown/creditcard.svg'}
          //     alt="Icon"
          //     boxSize={5}
          //   />
          // }
          // rightIcon={<FaArrowRight />}
          textDecoration={'none'}
          width={'full'}
          px={5}
          bg="lyk-green"
          color="white"
          _hover={{ opacity: 0.7 }}
          fontWeight={500}
          size={{ base: 'sm', sm: 'md' }}
          display={'flex'}
          className="items-center no-underline"
          onClick={onFlowBegin}
        >
          Redeem Balance
        </Button>
      ) : (
        <Button
          bg={verified ? 'transparent' : 'lyk-green'}
          color={verified ? 'lyk-green' : 'white'}
          _hover={{ opacity: 0.5 }}
          border={'solid'}
          borderColor={'lyk-green'}
          isDisabled={verified}
          mb={3}
          leftIcon={
            <Image
              boxSize={8}
              mr={-2}
              src={
                verified
                  ? '/account/green_check.svg'
                  : '/account/white_check.svg'
              }
              alt="Check"
            />
          }
          onClick={onFlowBegin}
        >
          {verified ? 'Verified!' : 'Verify to claim earnings'}
        </Button>
      )}
      <VerifyPhoneEmail
        isOpen={isMobileOtpVerifyOpen}
        onClose={() => {
          onCloseMobileOtpVerify()
        }}
        onVerifyClose={handleOTPVerifiedClose}
      />
      <StripeIndividual
        onClose={() => {
          onStripeClose()
          setCurrentStep(0)
        }}
        isOpen={isStripeOpen}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
      <UnderReviewModal
        isOpen={isOpenUnderReview}
        onClose={onCloseUnderReview}
        msg="Your account is under review"
        subtitle="Please wait while we review your account"
      />
      <Redeem
        isOpen={isOpenRedeem}
        onClose={() => {
          onCloseRedeem()
        }}
        user={user}
      />
    </>
  )
}

const getStepFromType = (type: 'personal' | 'bank' | 'verification') => {
  switch (type) {
    case 'personal':
      return 1
    case 'bank':
      return 2
    case 'verification':
      return 3
  }
}
